import React from 'react';
import { usePortalLanguage } from '../../../contexts/PortalLanguageContext';

function SessionExpiredOverlay({ onReverify, isLoading, error }) {
    const { t } = usePortalLanguage();
    const [lastName, setLastName] = React.useState('');

    const handleSubmit = (event) => {
        event.preventDefault();
        const trimmed = (lastName || '').trim();
        if (!trimmed) return;
        onReverify(trimmed);
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/45 backdrop-blur-[3px] p-4" role="dialog" aria-modal="true">
            <div className="w-full max-w-md rounded-2xl border border-[color:var(--border-color)] bg-[color:var(--surface-primary)] shadow-2xl p-6">
                <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[color:var(--color-accent)]">{t('Session expired')}</p>
                <h2 className="mt-2 text-2xl font-semibold text-[color:var(--text-primary)]">{t('Verify again to refresh')}</h2>
                <p className="mt-3 text-sm text-[color:var(--text-muted)]">{t('For your security, your session ended. Enter your last name to keep reading.')}</p>
                <form className="mt-5 space-y-4" onSubmit={handleSubmit}>
                    <div>
                        <label className="mb-1 block text-sm font-medium text-[color:var(--text-muted)]">{t('Client last name')}</label>
                        <input
                            type="text"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            className="w-full rounded-md border border-[color:var(--border-color)] bg-[color:var(--surface-primary)] text-[color:var(--text-primary)] px-3 py-3"
                            autoComplete="family-name"
                            autoFocus
                        />
                    </div>
                    {error && (
                        <div className="rounded-md border border-[color:var(--color-danger)]/20 bg-[color:var(--surface-danger)] px-3 py-2 text-sm text-[color:var(--color-danger)]">
                            {error}
                        </div>
                    )}
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full rounded-md bg-[color:var(--color-accent)] px-4 py-3 text-sm font-semibold text-[color:var(--on-accent)] hover:opacity-90 disabled:opacity-60"
                    >
                        {isLoading ? t('Verifying…') : t('Continue')}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default SessionExpiredOverlay;
